import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { tiposCampos, tratarNulos, mascaras_disponiveis } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye, FaQuestion } from "react-icons/fa";

class FormulariosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            nome: '',
            status: true,
            farmacovigilancia: '',
            erroLoadRegistro: "",
            tipo: '',
            formulario_id: "",
            titulo_pagina: "",
            loading: false,
            loading_campos: false,
            campos: [{ nome: '', descricao: '', ordem: '', tipo: '', obrigatorio: '', possui_ia: '', extencoes_permitidas: '', opcoes: '', mascara: '', slug: '', sessao: '', doenca_id: '', doenca_nome: '', campos_pdf: '' }],
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                formulario_id: id,
                titulo_pagina: 'Editando Formulário',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/formularios/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    status: dados.status,
                    farmacovigilancia: dados.farmacovigilancia,
                    tipo: dados.tipo,
                    loading: false
                });

                this.carregarCampos();
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar formulário, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                formulario_id: '',
                titulo_pagina: 'Adicionar Formulário',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            statusHelper: "",
            farmacovigilanciaHelper: "",
        });

        //vererifica se é edição ou adição
        const url = (this.state.formulario_id) ? '/formularios/'+this.state.formulario_id+'/' : '/formularios/'
        const metodo = (this.state.formulario_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('status', this.state.status);
        formData.append('tipo', this.state.tipo);
        formData.append('farmacovigilancia', this.state.farmacovigilancia);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.formulario_id) ? 'Formulário atualizado com sucesso' : 'Formulário cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.produto_id){
                this.props.router.navigate("/formularios");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o formulario, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'status'){
                        this.setState({ statusHelper: value })
                    }
                    if(key === 'tipo'){
                        this.setState({ tipoHelper: value })
                    }
                    if(key === 'farmacovigilancia'){
                        this.setState({ farmacovigilanciaHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    moverCampo = (index, direcao) => {
        let novosCampos = [...this.state.campos];
        let campoMovida = { ...novosCampos[index] };
    
        if (direcao === 'up' && index > 0) {
            // Troca o campo atual com a anterior
            novosCampos[index] = novosCampos[index - 1];
            novosCampos[index - 1] = campoMovida;
            // Atualiza a ordem (index baseado em 1 para a ordem)
            novosCampos[index].ordem = index + 1;
            novosCampos[index - 1].ordem = index;
        } else if (direcao === 'down' && index < novosCampos.length - 1) {
            // Troca a campo atual com a seguinte
            novosCampos[index] = novosCampos[index + 1];
            novosCampos[index + 1] = campoMovida;
            // Atualiza a ordem
            novosCampos[index].ordem = index + 1;
            novosCampos[index + 1].ordem = index + 2;
        }
    
        // Atualiza o estado
        this.setState({ campos: novosCampos }, () => {
            // Salva o campo movida com a nova ordem
            this.salvarCampo(index + (direcao === 'down' ? 1 : -1));
            // Salva o campo que foi substituída pela movida, para atualizar sua ordem
            this.salvarCampo(index);
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "status") {
            this.setState({ [name]: value === "true" });
        } else {
            this.setState({ [name]: value });
        }
    };

    handleChangeFarmacovigilancia = (event) => {
        const { name, type, checked, value } = event.target;
        this.setState({
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    //CAMPOS DO FORMULÁRIO
    carregarCampos = () => {
        if (this.state.loading_campos) {
            return;
        }

        if (this.state.formulario_id) {
            this.setState({ loading_campos: true });

            api.get(`/formularios/campos/?formulario_id=${this.state.formulario_id}&status=1&limit=500`)
                .then(response => {
                    const camposCarregados = (response.data.results || []).map(campo => {
                        let campos_pdf = campo.campos_pdf;

                        if (campos_pdf) {
                            if (typeof campos_pdf === 'string') {
                                // se vier como string, tenta parsear e reformatar
                                try {
                                    const parsed = JSON.parse(campos_pdf);
                                    campos_pdf = JSON.stringify(parsed, null, 4);
                                } catch (e) {
                                    // não é JSON válido, deixa a string como veio
                                }
                            } else {
                                // se vier como objeto (caso comum de JSONField)
                                campos_pdf = JSON.stringify(campos_pdf, null, 4);
                            }
                        } else {
                            campos_pdf = '';
                        }

                        return {
                            id: campo.id,
                            nome: campo.nome,
                            descricao: campo.descricao,
                            campos_pdf: campos_pdf,
                            ordem: campo.ordem,
                            tipo: campo.tipo,
                            obrigatorio: campo.obrigatorio,
                            possui_ia: campo.possui_ia,
                            extencoes_permitidas: campo.extencoes_permitidas,
                            opcoes: campo.opcoes,
                            mascara: campo.mascara,
                            slug: campo.slug,
                            sessao: campo.sessao,
                            doenca_id: campo.dados_doenca ? campo.dados_doenca.id : '',
                            doenca_nome: campo.dados_doenca ? campo.dados_doenca.nome : '',
                        };
                    });

                    this.setState({ campos: camposCarregados, loading_campos: false });
                })
                .catch(error => {
                    console.error('Erro ao carregar campos:', error);
                    
                    let erro_msg = 'Erro ao carregar campos do formulário, tente novamente';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading_campos: false,
                    });
                });
        }
    };


    carregarDoencas = async (inputValue) => {
        try {
            const response = await api.get(`/doencas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.id,
                label: doenca.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            //Sentry.captureException('Erro ao carregar doenças:', error);
            return [];
        }
    }

    salvarCampo = (index) => {
        const campo = this.state.campos[index];
        const url = campo.id ? `/formularios/campos/${campo.id}/` : '/formularios/campos/';
        const metodo = campo.id ? 'put' : 'post';
    
        const dadosCampo = {
            nome: campo.nome,
            tipo: campo.tipo,
            obrigatorio: (campo.obrigatorio) ? campo.obrigatorio : false,
            possui_ia: (campo.possui_ia) ? campo.possui_ia : false,
            formulario_id: this.state.formulario_id
        };

        if(campo.doenca_id) {
            dadosCampo['doenca_id'] = campo.doenca_id;
        }

        if(metodo == 'post') {
            if(campo.ordem) {
                dadosCampo['ordem'] = campo.ordem;
            } else {
                const ordem = index + 1;
                dadosCampo['ordem'] = ordem;
            }            
        } else {
            if(campo.ordem) {
                dadosCampo['ordem'] = campo.ordem;
            }
        }

        dadosCampo['descricao'] = campo.descricao || "";
        dadosCampo['extencoes_permitidas'] = campo.extencoes_permitidas || "";
        dadosCampo['opcoes'] = campo.opcoes || "";
        dadosCampo['mascara'] = campo.mascara || "";

        if(campo.slug) {
            dadosCampo['slug'] = campo.slug;
        }
        dadosCampo['sessao'] = campo.sessao || "";

        //Mapeamento farmacovigilância
        const txt = (campo.campos_pdf || '').trim();
        if (txt) {
            try {
                const parsed = JSON.parse(txt);  // valida e converte para objeto
                dadosCampo['campos_pdf'] = parsed;  // envia OBJETO pro JSONField
            } catch (e) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'warning',
                    title: <p>JSON inválido</p>,
                    text: 'Verifique a sintaxe do Mapeamento Farmacovigilância (campos_pdf).',
                    showCloseButton: true,
                });
                return; // cancela o salvar
            }
        } else {
            // sem nada no textarea => JSON vazio
            dadosCampo['campos_pdf'] = {};   
        }
        
    
        api({
            method: metodo,
            url: url,
            data: dadosCampo,
        })
        .then(response => {
            // Se for uma novo campo, atualize o estado com a ID retornada pela API
            if (!campo.id) {
                this.setState(prevState => {
                    const camposAtualizados = [...prevState.campos];
                    camposAtualizados[index].id = response.data.id;
                    return { campos: camposAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (campo.id) ? 'Campo atualizado com sucesso' : 'Campo cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o campo, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })
        });
    };

    adicionarCampo = () => {
        this.setState(prevState => ({
            campos: [...prevState.campos, { nome: '', descricao: '', ordem: '', tipo: '', obrigatorio: '', possui_ia: '', extencoes_permitidas: '', opcoes: '', mascara: '', slug: '', sessao: '', doenca_id: '', doenca_nome: '', campos_pdf: '' }],
        }));
    };

    removerCampo = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover campo?',
            text: "Tem certeza que deseja remover este campo?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const campo = this.state.campos[index];

                if (campo.id) {

                    const url = `/formularios/campos/${campo.id}/`;
                    const metodo = 'put';
                
                    const dadosCampo = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosCampo,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Campo removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            campos: prevState.campos.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o campo, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        campos: prevState.campos.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O campo foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleCampoChange = (index, event, fieldName) => {
        if(fieldName == 'doenca') {
           
            const campos = [...this.state.campos];

            campos[index] = { ...campos[index], doenca_id: event.value, doenca_nome: event.label };
            this.setState({ campos });

        } else {
            const { name, value, type } = event.target;
            
            const campos = [...this.state.campos];
            let valorAtualizado = value;

            // Se o campo for um <select> e representar um valor booleano, converte o valor para boolean
            if (type === "select-one" && (name === "obrigatorio" || name === "possui_ia")) {
                valorAtualizado = value === "true"; // Converte a string "true" ou "false" para boolean
            }

            campos[index] = { ...campos[index], [name]: valorAtualizado };
            this.setState({ campos });
        }
    };

    openMascaraModal = () => 
        this.setState({ showMascaraModal: true });

    closeMascaraModal = () => 
        this.setState({ showMascaraModal: false });

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosDoFormulario" id="tabs-formulario" className="aditus-tabs">
                    <Tab eventKey="dadosDoFormulario" title="Dados do Formulário">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Formulário</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Formulário</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome do Formulário" value={this.state.nome} onChange={this.handleChange} />
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Status do Formulário</Form.Label>
                                                <Form.Select className="form-control" name="status" value={this.state.status.toString()} onChange={this.handleChange}>
                                                    <option value="true">Ativo</option>
                                                    <option value="false">Inativo</option>
                                                </Form.Select>
                                                <Form.Text id="formStatusHelpBlock" className="text-danger">
                                                    {this.state.statusHelper}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo do Formulário</Form.Label>
                                                <Form.Select className="form-control" name="tipo" value={this.state.tipo} onChange={this.handleChange}>
                                                    <option value="normal" selected>Normal</option>
                                                    <option value="pesquisa">Pesquisa</option>
                                                </Form.Select>
                                                <Form.Text id="formTipoHelpBlock" className="text-danger">
                                                    {this.state.tipoHelper}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Formulário de Farmacovigilância</Form.Label>
                                                <Form.Check
                                                    type="checkbox"
                                                    name="farmacovigilancia"
                                                    checked={this.state.farmacovigilancia}
                                                    onChange={this.handleChangeFarmacovigilancia}
                                                />
                                            </Form.Group>
                                        </Col>   
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                               
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    {this.state.formulario_id && (
                        <Tab eventKey="camposFormulario" title="Campos do Formulário">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaCamposFormulario}>
                                        <h4>Campos do Formulário</h4>
                                        {this.state.campos && !this.state.loading_campos && (
                                            this.state.campos.map((campo, index) => (
                                                <div key={index} className="row-list">
                                                    <Row>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Nome</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="nome" 
                                                                    value={campo.nome} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Seção</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="sessao" 
                                                                    value={campo.sessao} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Tipo do Campo</Form.Label>
                                                                <Form.Control as="select" name="tipo" value={campo.tipo} required onChange={e => this.handleCampoChange(index, e)}>
                                                                    <option value="">Tipo</option>
                                                                    {Object.entries(tiposCampos).map(([sigla, nome]) => (
                                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Doença</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarDoencas}
                                                                    defaultOptions
                                                                    placeholder="Buscar doença..."
                                                                    noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                                    onChange={e => this.handleCampoChange(index, e, 'doenca')}
                                                                    value={campo.doenca_id ? { value: campo.doenca_id, label: campo.doenca_nome } : null}
                                                                />
                                                                <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                    Caso informe uma doença, esse campo só será exibido para atendimentos relacionados a essa doença.
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Máscara para Campo</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="mascara" 
                                                                    value={campo.mascara} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                                <Form.Text className="text-muted" style={{ fontSize: '0.9em' }}>
                                                                    Possível fornecer máscara para o campo:{' '}
                                                                        <Button
                                                                            variant="link"
                                                                            className="p-0 ms-1 align-baseline"
                                                                            onClick={this.openMascaraModal}
                                                                            aria-label="Ver máscaras disponíveis"
                                                                            title="Ver máscaras disponíveis"
                                                                        >
                                                                            <FaEye />
                                                                        </Button>
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Slug</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="slug" 
                                                                    value={campo.slug} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Campo Obrigatório?</Form.Label>
                                                                <Form.Select className="form-control" name="obrigatorio" value={campo.obrigatorio.toString()} onChange={e => this.handleCampoChange(index, e)}>
                                                                    <option value="false">Não</option>
                                                                    <option value="true">Sim</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Ordem</Form.Label>
                                                                <Form.Control 
                                                                    type="number" 
                                                                    name="ordem" 
                                                                    value={campo.ordem} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {(campo.tipo == 'area_texto') && (
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Possui Inteligência Artifical?</Form.Label>
                                                                <Form.Select className="form-control" name="possui_ia" value={campo.possui_ia.toString()} onChange={e => this.handleCampoChange(index, e)}>
                                                                    <option value="false">Não</option>
                                                                    <option value="true">Sim</option>
                                                                </Form.Select>
                                                                <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                    Indica se o campo terá opção para ser preenchido com Inteligência Artifical
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        )}
                                                    </Row>
                                                    {(campo.tipo == 'arquivo') && (
                                                    <Row>
                                                        <Col>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Extensões Permitidas</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="extencoes_permitidas" 
                                                                    value={campo.extencoes_permitidas} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                            </Form.Group>
                                                            <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                Informe as extensões permitidas para o campo separadas por vírgula, por exemplo: .jpg, .png, .pdf
                                                            </Form.Text>
                                                        </Col>
                                                    </Row>
                                                    )}
                                                    {(campo.tipo == 'selecao' || campo.tipo == 'checkbox' || campo.tipo == 'radio') && (
                                                    <Row>
                                                        <Col>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Valores do Campo</Form.Label>
                                                                <Form.Control 
                                                                    as="textarea" 
                                                                    name="opcoes" 
                                                                    value={campo.opcoes} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                                <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                    Informe as opções disponíveis para escolha do campo no formato chave:valor com um item por linha. Por exemplo, para um campo para escolha de cor as opções poderiam ser:<br />
                                                                    vermelho:Vermelho<br />
                                                                    azul:Azul<br />
                                                                    verde:Verde
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    )}
                                                    <Row>
                                                        <Col>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Descrição</Form.Label>
                                                                <Form.Control 
                                                                    as="textarea" 
                                                                    name="descricao" 
                                                                    value={campo.descricao} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Mapeamento Farmacovigilância</Form.Label>
                                                                <Form.Control 
                                                                    as="textarea" 
                                                                    name="campos_pdf"
                                                                    rows={8} 
                                                                    value={campo.campos_pdf || ''} 
                                                                    onChange={e => this.handleCampoChange(index, e)} 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={4}>
                                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarCampo(index)}><FaCheck className="me-1" /> Salvar Campo</Button>&nbsp;&nbsp;
                                                        <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerCampo(index)}><FaTimes className="me-1" /> Remover Campo</Button>
                                                        </Col>
                                                    <Col sm={8}>
                                                        Ordenar &nbsp;&nbsp;&nbsp;
                                                        {campo.id && index > 0 && (
                                                            <Button variant="outline-primary" className="btn-sm me-2" onClick={() => this.moverCampo(index, 'up')}><FaArrowUp /></Button>
                                                        )}
                                                        {campo.id && index < this.state.campos.length - 1 && (
                                                            <Button variant="outline-primary" className="btn-sm" onClick={() => this.moverCampo(index, 'down')}><FaArrowDown /></Button>
                                                        )}
                                                    </Col>
                                                    </Row>
                                                </div>
                                            ))
                                        )}
                                        <Button variant="secondary" onClick={this.adicionarCampo}><FaStream /> Adicionar Campo</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}
                </Tabs>
                <Modal show={this.state.showMascaraModal} onHide={this.closeMascaraModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Máscaras disponíveis</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ul className="mb-0">
                             {Object.entries(mascaras_disponiveis).map(([sigla, nome]) => (
                                <option key={sigla} value={sigla}>{nome}</option>
                            ))}
                        </ul>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeMascaraModal}>
                        Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default withRouter(FormulariosEdit);
